import { z } from 'zod';

import { Role } from '@optical/rbac';

export type CreateInvitationPayload = z.output<typeof createInvitationPayloadSchema>;
export type CreateInvitationPayloadDTO = z.input<typeof createInvitationPayloadSchema>;

/**
 * Body schema for creating an invitation.
 *
 * Stricter than `invitationParamsSchema`, which has to stay lenient enough to read back rows
 * written before player invitations were split into "link a player" and "invite by name". New
 * player invitations must be one or the other, so the invitee always has something to land on:
 * a roster player to link to, or a name to prefill their new profile with.
 */
export const createInvitationPayloadSchema = z.discriminatedUnion('role', [
  z.object({
    email: z.email(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    role: z.literal(Role.CUSTOMER),
  }),
  z.object({
    email: z.email(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    role: z.literal(Role.GUEST),
  }),
  z.object({
    email: z.email(),
    firstName: z.string().min(1).optional(),
    lastName: z.string().min(1).optional(),
    playerId: z.uuid().optional(),
    role: z.literal(Role.PLAYER),
  }),
]);
